export const capitalizeFirstLetter = (str) => {
    if (str && str.length > 0) {
        return str.charAt(0).toUpperCase() + str.slice(1);
      }
      return str;
  };
  export default class Helper{
    static validatePassword(password) {
        return new RegExp(
          "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})"
        ).test(password); // eslint-disable-line
      }
  }
 